import { NgModule } from '@angular/core';
import { MaterialModule } from '../material-module/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import {
  ButtonComponent,
  SaButtonDirective,
  SaDangerButtonDirective,
  SaSecondaryButtonDirective,
} from './button/button.component';
import { MapSearchComponent } from './map-search/map-search.component';
import { MapSearchInputComponent } from './map-search/map-search-input.component';
import { MapSearchResultsComponent } from './map-search/map-search-results.component';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetailViewComponent } from './detail-view/detail-view.component';
import { DriverDetailViewComponent } from './detail-view/driver-detail-view.component';
import { SiteDetailViewComponent } from './detail-view/site-detail-view.component';
import { DriverProfileDetailViewComponent } from './detail-view/driver-profile-detail-view.component';
import { NavComponent } from './nav/nav.component';
import { SubnavComponent } from './subnav/subnav.component';
import { HighlightSearchPipe } from '../pipes/highlight.pipe';
import { DetailViewInputComponent } from './detail-view-input/detail-view-input.component';
import { UserDetailViewComponent } from './detail-view/user-detail-view.component';
import { PhoneNumberPipe } from '../pipes/phone-number.pipe';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { CardComponent } from './card/card.component';
import { TopNavComponent } from './top-nav/top-nav.component';
import { SaNumberInputDirective } from './sa-number-input/sa-number-input.directive';
import { TooltipTimestampPipe } from '../pipes/tooltip-timestamp.pipe';
import { FilterPipe } from '../pipes/filter.pipe';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ChoiceDialogComponent } from './choice-dialog/choice-dialog.component';
import { ReassignDialogComponent } from './reassign-dialog/reassign-dialog.component';
import { DeclineDialogComponent } from './decline-dialog/decline-dialog.component';
import { MapGeneralComponent } from './map-general/map-general.component';
import { NumberDecimalPipe } from '../pipes/number-decimal.pipe';
import { SandiPageComponent } from './sandi-page/sandi-page.component';
import { BulkDeclineDialogComponent } from './bulk-decline-dialog/bulk-decline-dialog.component';
import { AutomatedSelectorDirective } from './automated-selector/automated-selector.directive';
import { DisableFormatDirective } from './scroll-input/disable-format.directive';
import { NavTopBarComponent } from './nav-top-bar/nav-top-bar.component';
import { FeatureFlagPipe } from '../feature-flag.pipe';
import { FeatureFlagDirective } from '../feature-flag.directive';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { ReassignTruckComponent } from './reassign-truck/reassign-truck.component';
import { OrderMapControlsComponent } from './order-map-controls/order-map-controls.component';
import { MphPipe } from '../pipes/mph.pipe';
import { OrderPredictionComponent } from './order-prediction/order-prediction.component';
import { FracDetailCompletedOrdersComponent } from './frac-detail-completed-orders/frac-detail-completed-orders.component';
import { FilteredAutocompleteComponent } from './filtered-autocomplete/filtered-autocomplete.component';
import { CurrencyInputDirective } from './currency-input.directive';
import { pipes } from './pipes';
import { NetworkActiveButtonComponent } from './network-active-button/network-active-button.component';
import { AllowedAccountTypesDirective } from './allowed-account-types.directive';
import { AllowedAccountTypesEnabledForDirective } from './allowed-account-types-enabled.directive';
import { TopNavWithIconComponent } from './top-nav-with-icon/top-nav-with-icon.component';
import { CountdownPipe } from '../countdown.pipe';
import { NgxMatIntlTelInputModule } from 'ngx-mat-intl-tel-input';
import { UserPermissionDirective } from '../user-permission.directive';
import { FracNamePipe } from './pipes/frac-name.pipe';
import { HighlightPipe } from './pipes/highlight.pipe';
import { OrderSearchDirective } from './order-search.directive';
import { OrderSearchHotkeyComponent } from './order-search-hotkey/order-search-hotkey.component';
import { NavLmoComponent } from './nav-lmo/nav-lmo.component';
import { OnOrderTooLongPipe } from '../pipes/on-order-too-long.pipe';
import { LongEscapeTipComponent } from './long-escape-tip/long-escape-tip.component';
import { LongEscapeComponent } from './long-escape/long-escape.component';
import { LongEscapeDirective } from './long-escape.directive';
import { ProgressiveRenderPipe } from './pipes/progressive-render.pipe';
import { CurrencyInPenniesPipe } from './pipes/currency-in-pennies.pipe';
import { AccountTypeDirective } from './account-type-with-permissions.directive';
import { NewBillingPortalOptInComponent } from './new-billing-portal-opt-in/new-billing-portal-opt-in.component';
import { ConfirmActionDialogComponent } from './confirm-action-dialog/confirm-action-dialog.component';
import { PluckPipe } from './pipes/pluck.pipe';
import { JoinWithAndPipe } from './pipes/join-with-and.pipe';
import { LohiPreloadStatusComponent } from './lohi-preload-status/lohi-preload-status.component';
import { TrackByKeyPipe } from './track-by-key.pipe';
import { StandardDatePipe } from './standard-date.pipe';
import { DistributionCenterNamePipe } from './pipes/distribution-center-name.pipe';
import { PoLoaderPoundTonConversionPipe } from './pipes/po-loader-pound-ton-conversion.pipe';
import { PoLoaderPoundTonUnitPipe } from './pipes/po-loader-pound-ton-unit.pipe';
import { BulkExportColumnsComponent } from './bulk-export-columns/bulk-export-columns.component';
import { AddEditExportColumnsTemplateComponent } from './bulk-export-columns/add-edit-export-columns-template/add-edit-export-columns-template.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule,
    MatAutocompleteModule,
    NgxMatIntlTelInputModule,
  ],
  declarations: [
    ButtonComponent,
    SaButtonDirective,
    SaSecondaryButtonDirective,
    SaDangerButtonDirective,
    MapSearchComponent,
    MapSearchInputComponent,
    MapSearchResultsComponent,
    DetailViewComponent,
    SiteDetailViewComponent,
    DriverDetailViewComponent,
    DriverProfileDetailViewComponent,
    UserDetailViewComponent,
    NavComponent,
    TopNavComponent,
    SubnavComponent,
    DetailViewInputComponent,
    LoadingSpinnerComponent,
    CardComponent,
    HighlightSearchPipe,
    TooltipTimestampPipe,
    PhoneNumberPipe,
    FilterPipe,
    NumberDecimalPipe,
    SaNumberInputDirective,
    ChoiceDialogComponent,
    ReassignDialogComponent,
    DeclineDialogComponent,
    MapGeneralComponent,
    SandiPageComponent,
    BulkDeclineDialogComponent,
    AutomatedSelectorDirective,
    DisableFormatDirective,
    NavTopBarComponent,
    FeatureFlagPipe,
    FeatureFlagDirective,
    OrderSummaryComponent,
    ReassignTruckComponent,
    OrderMapControlsComponent,
    MphPipe,
    OrderPredictionComponent,
    FracDetailCompletedOrdersComponent,
    FilteredAutocompleteComponent,
    CurrencyInputDirective,
    ...pipes,
    NetworkActiveButtonComponent,
    AllowedAccountTypesDirective,
    AllowedAccountTypesEnabledForDirective,
    TopNavWithIconComponent,
    UserPermissionDirective,
    CountdownPipe,
    FracNamePipe,
    DistributionCenterNamePipe,
    HighlightPipe,
    OrderSearchDirective,
    OrderSearchHotkeyComponent,
    NavLmoComponent,
    OnOrderTooLongPipe,
    LongEscapeTipComponent,
    LongEscapeComponent,
    LongEscapeDirective,
    ProgressiveRenderPipe,
    CurrencyInPenniesPipe,
    AccountTypeDirective,
    NewBillingPortalOptInComponent,
    ConfirmActionDialogComponent,
    PluckPipe,
    JoinWithAndPipe,
    LohiPreloadStatusComponent,
    TrackByKeyPipe,
    StandardDatePipe,
    PoLoaderPoundTonConversionPipe,
    PoLoaderPoundTonUnitPipe,
    BulkExportColumnsComponent,
    AddEditExportColumnsTemplateComponent,
  ],
  exports: [
    ButtonComponent,
    SaButtonDirective,
    SaSecondaryButtonDirective,
    SaDangerButtonDirective,
    MapSearchComponent,
    MapSearchInputComponent,
    MapSearchResultsComponent,
    DetailViewComponent,
    SiteDetailViewComponent,
    DriverDetailViewComponent,
    DriverProfileDetailViewComponent,
    UserDetailViewComponent,
    NavComponent,
    TopNavComponent,
    SubnavComponent,
    DetailViewInputComponent,
    LoadingSpinnerComponent,
    CardComponent,
    HighlightSearchPipe,
    PhoneNumberPipe,
    FilterPipe,
    NumberDecimalPipe,
    SaNumberInputDirective,
    ReassignDialogComponent,
    DeclineDialogComponent,
    MapGeneralComponent,
    SandiPageComponent,
    BulkDeclineDialogComponent,
    AutomatedSelectorDirective,
    DisableFormatDirective,
    NavTopBarComponent,
    FeatureFlagPipe,
    FeatureFlagDirective,
    MphPipe,
    OrderSummaryComponent,
    FilteredAutocompleteComponent,
    CurrencyInputDirective,
    ...pipes,
    NetworkActiveButtonComponent,
    AllowedAccountTypesDirective,
    AllowedAccountTypesEnabledForDirective,
    TopNavWithIconComponent,
    CountdownPipe,
    NgxMatIntlTelInputModule,
    UserPermissionDirective,
    FracNamePipe,
    DistributionCenterNamePipe,
    OrderSearchDirective,
    OrderSearchHotkeyComponent,
    NavLmoComponent,
    OnOrderTooLongPipe,
    LongEscapeDirective,
    AccountTypeDirective,
    NewBillingPortalOptInComponent,
    ConfirmActionDialogComponent,
    PluckPipe,
    JoinWithAndPipe,
    LohiPreloadStatusComponent,
    TrackByKeyPipe,
    StandardDatePipe,
    PoLoaderPoundTonConversionPipe,
    PoLoaderPoundTonUnitPipe,
    BulkExportColumnsComponent,
  ],
  entryComponents: [
    OrderSearchHotkeyComponent,
    LongEscapeComponent,
    LongEscapeTipComponent,
    NewBillingPortalOptInComponent,
    ConfirmActionDialogComponent,
  ],
})
export class UIComponentsModule {}
